module.exports = __webpack_public_path__ + "img/msu3-2.3f03b4c5.png";